import TextBox from "devextreme-react/text-box";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { emailApi } from '../../../api/emailApi';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import SelectBoxEmailTemplate from "../../../components/editor/cb_email_template";
import SelectBoxEmail from '../../../components/editor/selectbox_email';
import _ from 'lodash'
const SendEmailModal = ({ selectedRowKeys, dataSource, onSuccess, onCancel, username }) => {
    const { translate } = useCommonContext();
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const { user } = useSelector((x) => x.auth);

    const _dataSource = useMemo(() => {
        return dataSource.filter((val) => selectedRowKeys.includes(val.id)).map((value) => {
            const _key = Object.keys(value).filter((val) => !val.includes("T_") && !val.includes("Id_"));
            const _val = _.pick(value, _key)
            return { ..._val, ID: value.id, error: "" }
        })
    }, [dataSource, selectedRowKeys])
    const [formData, setFormData] = useState({
        id: 0,
        ts_email_template_id: 0,
        subject: '',
        body: '',
        dm_trangthai_email_id: 4,
        total_user: 0,
        total_success: 0,
        total_fail: 0,
        send_schedule: null,
        dm_cauhinhemail_id: 0,
        user_id_pheduyet: user.id,
        user_id_daduyet: user.id,
        user_id_ngayduyet: new Date(),
        dm_coso_id: dm_coso_id
    });
    const [isSaving, setIsSaving] = useState(false);
    const { trigger, errors } = useForm();
    const handleSaveChanges = async () => {
        trigger().then(async (isValid) => {
            if (isValid) {
                if (formData.ts_email_template_id == 0) {
                    showNotify({ text: 'Vui lòng chọn theo mẫu email', type: 'error' });
                    return;
                }
                if (formData.subject == '') {
                    showNotify({ text: 'Vui lòng nhập tiêu đề email', type: 'error' });
                    return;
                }
                try {
                    setIsSaving(true);
                    _dataSource.forEach(element => {
                        var email = "";
                        if (element.TC_2014 != '' && element.TC_2014 != null) {
                            email = email + element.TC_2014;
                        }

                        if (element.TC_2020 != '' && element.TC_2020 != null) {
                            email = email + "," + element.TC_2020;
                        }

                        if (element.TC_2026 != '' && element.TC_2026 != null) {
                            email = email + "," + element.TC_2026;
                        }
                        element.email = email;
                    });
                    const datasend = { ts_email: formData, isSendPheDuyet: false }
                    const res = await emailApi.Insert(datasend);
                    if (res.is_success) {
                        const datainsert = ({
                            id: res.data,
                            ts_email_template_id: formData.ts_email_template_id,
                            subject: formData.subject,
                            body: formData.body,
                            data_source: _dataSource,
                            total_user: _dataSource.length,
                            ts_email_status_id: 4,
                            dm_cauhinhemail_id: formData.dm_cauhinhemail_id,
                            user_id_pheduyet: formData.user_id_pheduyet,
                            user_id_daduyet: formData.user_id_pheduyet,
                            user_id_ngayduyet: new Date(),
                        })
                        console.log(datainsert);
                        const res2 = await emailApi.SaveAsync(datainsert)

                        if (res2.is_success) {
                            const res3 = await emailApi.SavePheDuyet(res.data);
                            if (res3.is_success) {
                                showNotify({ text: translate('Gửi thành công '), type: 'success' });
                            } else {
                                showNotify({ text: res.message, type: "error" });
                            }
                        } else {
                            showNotify({ text: res2.message, type: 'error' });
                        }
                    } else {
                        showNotify({ text: res.message, type: 'error' });
                    }
                } catch (error) {
                    showNotify({ text: error.message, type: 'error' });
                } finally {
                    setIsSaving(false);
                    onSuccess()
                }

            }
        });
    };
    return (
        <div>
            <Modal
                open={true}
                size='small'
                dimmer={'blurring'}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>{formData.id > 0 ? <p>{translate('Cập nhật')}</p> : <p>{translate('Tạo đợt gửi mới')}</p>}</Modal.Header>
                <Modal.Content>
                    <form className='ui'>
                        <input className='hide' name='id' defaultValue={formData.id}></input>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='dx-field-label'>{translate('Tiêu đề gửi email')}</div>
                                <br></br>
                                <TextBox
                                    stylingMode='outlined'
                                    onValueChanged={(e) => {
                                        setFormData((prev) => ({ ...prev, subject: e.value }));

                                    }}
                                    value={formData.subject}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 padding-top-1rem'>
                                <div className='dx-field-label'>{translate('Gửi từ email')}</div>
                                <br></br>
                                <SelectBoxEmail
                                    onValueChanged={(value) => {
                                        setFormData((prev) => ({ ...prev, dm_cauhinhemail_id: value }));

                                    }}
                                    value={formData.dm_cauhinhemail_id}
                                    user={username}
                                    showClearButton={true}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 padding-top-1rem'>
                                <div className='dx-field-label'>{translate('Mẫu email')}</div>
                                <br></br>
                                <SelectBoxEmailTemplate
                                    dm_coso_id={dm_coso_id}
                                    onValueChangedWithBody={(value) => {
                                        if (value) {

                                            setFormData((prev) => ({ ...prev, ts_email_template_id: value.id, body: value.body }));
                                        }

                                    }}
                                    value={formData.ts_email_template_id}
                                    showClearButton={true}
                                />
                            </div>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={'Đóng'} onClick={onCancel} />
                        <PrimaryButton text={'Lưu'} onClick={handleSaveChanges} isLoading={isSaving} />


                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};
export default SendEmailModal;
